export const ESTIMATE_STATUS_OPTIONS = [
  { value: "Bản nháp", label: "Bản nháp" },
  { value: "Đã xác nhận", label: "Đã xác nhận" },
];
